import { LabelItemType } from "@/types/view";
import { AppConstant, SystemConstant } from "@/const";
import { useTranslation } from "react-i18next";

const useRequestStatusList = () => {
  const { t: getLabel } = useTranslation();

  const reqStatusList: LabelItemType[] = [
    {
      value: AppConstant.SELECT_ALL,
      label: getLabel("OBJ_STATUS_REQUEST.all"),
    },
    {
      value: String(SystemConstant.STATUS_REQUEST.created),
      label: getLabel("OBJ_STATUS_REQUEST.created"),
    },
    {
      value: String(SystemConstant.STATUS_REQUEST.success),
      label: getLabel("OBJ_STATUS_REQUEST.success"),
    },
    {
      value: String(SystemConstant.STATUS_REQUEST.failed),
      label: getLabel("OBJ_STATUS_REQUEST.failed"),
    },
    {
      value: String(SystemConstant.STATUS_REQUEST.approvedIncomingData),
      label: getLabel("OBJ_STATUS_REQUEST.processing"),
    },
  ];

  return reqStatusList;
};

export default useRequestStatusList;
